import { useEffect } from "react"
import _isNil from "lodash/isNil"
import { getTrafficSummary } from "services/state/actions"

export const useTrafficData = (productSelected) => (dispatch, getState) => {
  useEffect(() => {
    if (_isNil(productSelected)) return
    getTrafficSummary({ contractId: productSelected.serviceId })(
      dispatch,
      getState
    )
  }, [productSelected])
}



// WEBPACK FOOTER //
// ./src/scenes/DataQuota/utils/useTrafficData.js